import script from "./EditMenuPrivilegePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditMenuPrivilegePage.vue?vue&type=script&lang=ts&setup=true"

import "./EditMenuPrivilegePage.vue?vue&type=style&index=0&id=aa095aa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa095aa4"]])

export default __exports__